export const DEPARTMENT_DOCUMENT_DROP_DOWN_ITEMS = []